/* esm.sh - rxjs@7.8.1/dist/esm/internal/util/executeSchedule */
function l(e,d,i,u=0,s=!1){let c=d.schedule(function(){i(),s?e.add(this.schedule(null,u)):this.unsubscribe()},u);if(e.add(c),!s)return c}export{l as executeSchedule};
//# sourceMappingURL=executeSchedule.mjs.map